import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsPagelessAddBlocksTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_PAGELESS_ADD_BLOCKS;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_REPORTS_PAGELESS_ADD_BLOCKS;

	get id(): string {
		return TourId.REPORTS__PAGELESS_ADD_BLOCKS;
	}

	override get keyForPersistantDone(): string {
		return ReportsPagelessAddBlocksTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				allowStacked: false,
				attachTo: () => {
					// Target the "Add blocks" button in ReportsFragmentGridAddRow (the + icon)
					return $('.add-fragment--row .add-fragment-button');
				},
				scrollToAttachTo: true,
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override onExplicitClose(): void {
		this.flowTourReportsPagelessService.endAllTours();
		super.onExplicitClose();
	}
}
